import { render, staticRenderFns } from "./MaterialRequestForm.vue?vue&type=template&id=27d6be1d&"
import script from "./MaterialRequestForm.vue?vue&type=script&lang=ts&"
export * from "./MaterialRequestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports